export default "__VITE_ASSET__CsSf69ic__"